import SwitchOrganizaitonButton from '@v2/domains/organization/components/SwitchOrganizationButton/SwitchOrganizationButton.component'

import { Portal, SearchField } from 'src/common/components'
import { useDocumentTitle } from 'src/common/hooks'

import withErrorBoundaryAndPolicyCheck from '../../../v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import Sidebar from './Sidebar'
import Topbar from './Topbar'
import styles from './basic-template-wrapper.module.scss'

const BasicTemplateWrapper = (props: React.PropsWithChildren<{}>) => {
  const { children } = props
  useDocumentTitle('')

  return (
    <>
      <div className={styles.wrapper}>
        <Sidebar />

        <div className={styles.inner}>
          <Topbar>
            <SwitchOrganizaitonButton />

            <Portal.Target
              className={styles.desktopSearch}
              id="searchField"
              media="desktop"
            />
          </Topbar>
          {children}
        </div>
      </div>

      <SearchField />
    </>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  BasicTemplateWrapper,
  'is_enable_benestream_basic_template',
  true,
)
